module.exports = __webpack_public_path__ + "img/d2.7ca348a0.jpg";